import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    "model-value": _ctx.modelValue,
    options: _ctx.filteredRoles,
    "option-value": "id",
    label: "Role",
    loading: _ctx.isLoading,
    "map-options": !_ctx.object
  }, _ctx.$attrs, { "onUpdate:modelValue": _ctx.select }), {
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.opt.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_label, { caption: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.opt.description), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    "selected-item": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.selectedText), 1)
    ]),
    _: 1
  }, 16, ["model-value", "options", "loading", "map-options", "onUpdate:modelValue"]))
}